import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useBusinessAuth } from '../context/BusinessAuthContext';
import { useTheme } from '../context/ThemeContext';

export function BusinessProtectedRoute({ children, requireOrg = true }) {
  const { supabaseConfigured, loading, session, activeOrgId } = useBusinessAuth();
  const { t } = useTheme();
  const location = useLocation();

  const screenStyle = {
    minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center',
    justifyContent: 'center', gap: '0.75rem', background: t.pageBg, color: t.textMutedNew,
    fontFamily: "'Barlow', sans-serif", fontSize: '0.875rem', textAlign: 'center', padding: '1rem',
  };

  if (!supabaseConfigured) {
    return (
      <div style={screenStyle} data-testid="biz-unconfigured-state">
        <h2 style={{ color: t.textPrimary, fontSize: '1.25rem' }}>Business Workspace isn't configured yet</h2>
        <p>Supabase credentials haven't been added to this environment. Ask an admin to finish the Supabase setup checklist.</p>
        <a href="/" style={{ color: t.accent, fontSize: '0.75rem', textDecoration: 'underline' }} data-testid="biz-unconfigured-back-link">
          Back to Divispend
        </a>
      </div>
    );
  }

  if (loading) {
    return (
      <div style={screenStyle} data-testid="biz-loading-state">
        <p>Loading your workspace…</p>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/biz/login" state={{ from: location }} replace />;
  }

  if (requireOrg && !activeOrgId) {
    return <Navigate to="/biz/orgs" replace />;
  }

  return children;
}
